'use client'

import { useResponsive } from '@dustin-web/microsite-components/src/hooks'
import { usePathname } from 'next/navigation'
import CampaignBannerInternal from './campaign-banner-internal'
import { GetCampaignBannerResultQuery } from '@dustin-web/microsite-data/src/graphql/content/generated/graphql-types'
import { GET_CAMPAIGN_BANNER_RESULT } from '@dustin-web/microsite-data/src/graphql/content/get-campaign-banner.graphql'
import { useGraphql } from '@dustin-web/microsite-data/src/hooks'
import { campaignBannerUrlExceptions } from '@dustin-web/microsite-data/src/utils'

const CampaignBanner = () => {
  const { breakpoints } = useResponsive()
  const pathname = usePathname() || ''

  const urlExceptions = campaignBannerUrlExceptions

  // if checking a url all suburls with be valid aswell
  const currentPathIsException = urlExceptions.some((phrase: string) => pathname?.includes(phrase))

  const { data } = useGraphql<GetCampaignBannerResultQuery>(GET_CAMPAIGN_BANNER_RESULT, {
    context: { skip: currentPathIsException },
  })

  if (currentPathIsException || !data) {
    return null
  }

  return <CampaignBannerInternal breakpoints={breakpoints} data={data} />
}

export default CampaignBanner
